module.exports = __webpack_public_path__ + "img/compress-wide.b556e6df.svg";